<h2 mat-dialog-title>{{ 'components.verification-charge.title' | translate }}</h2>
<div mat-dialog-content>
    <h3 class="text-default-gray">{{ 'components.verification-charge.info_1' | translate }}</h3>
    <div class="font-primary text-xl text-center text-default-gray m-2">
      💵${{verificationAmount}}💵
    </div>
    <p class="text-default-gray text-justify text-sm">
      {{ 'components.verification-charge.info_2' | translate }}&nbsp;
      {{ 'components.verification-charge.info_3' | translate }}&nbsp;
      <b>{{ 'components.verification-charge.info_4' | translate }}</b>
    </p>
</div>
<mat-dialog-actions align="end">
    <button class="w-full" mat-stroked-button mat-dialog-close cdkFocusInitial>Cerrar</button>
</mat-dialog-actions>
